module.exports = "/img/mail.png?e101106b699359fcf0a117e62d1105dd";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/mail.png
// module id = kK13
// module chunks = 54